module.exports = __webpack_public_path__ + "img/placeholder-thumb.1ecba3e9.png";